import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-md-8 col-md-offset-2 intro-text">
                <h1 className="responsive-heading">
                  {props.data ? props.data.title : "Loading"}
                </h1>
                <p className="responsive-text">
                  {props.data ? props.data.paragraph : "Loading"}
                </p>
                {props.data && props.data.showButton && (
                  <a 
                    href={props.data.buttonLink || "#history"} 
                    className="btn btn-custom btn-lg page-scroll"
                  >
                    {props.data.buttonText || "Learn More"}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
